import { createAdminRequest, createRequest } from '../helpers/api_utils';
import { Organization, OrganizationCreate } from '../types/admin_types';
import { apiUrl } from './api_url';

const apiEndpoint = apiUrl + '/organization';
const apiAdminEndpoint = apiUrl + '/admin/organization';

export async function getOrganization() {
  return fetch(createRequest(apiEndpoint, 'GET', 'application/json', true));
}

export async function getOrganizationById(organization_id: string) {
  return fetch(createRequest(apiEndpoint + `/${organization_id}`, 'GET', 'application/json', true));
}

export async function updateOrganization(organization: Organization) {
  return fetch(createRequest(apiEndpoint, 'PUT', 'application/json', true, organization));
}

export async function createOrganization(organization: OrganizationCreate) {
  return fetch(createAdminRequest(apiAdminEndpoint, 'POST', 'application/json', true, organization));
}

export async function getOrganizationLogo() {
  return fetch(createRequest(apiEndpoint + '/init', 'GET', 'application/json', true));
}

export async function deleteChildCompany(childCompanyId: string) {
  return fetch(createRequest(`${apiEndpoint}/child-companies/${childCompanyId}`, 'DELETE', 'application/json', true));
}